function getEnv() {
    if (typeof env != 'undefined') {
        return env;
    }
    return 'prod';
}

if (getEnv() == 'dev' || getEnv() == 'test') {
    //	stg
    window["initiative_id"] = "112";
    window["environment"] = "stg";
} else {
    //	prd
    window["initiative_id"] = "1112";
    window["environment"] = "prd";
}